<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <!-- rederizando componente alert -->
        <alert></alert>
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Distribuições</b>
            </h3>
            <button v-on:click="distribuir" class="btn btn-primary pull-right">
              <i class="fa fa-share-alt-square"></i> Distribuir
            </button>
          </div>
          <div class="box-body">
            <div class="row" style="margin-top:15px">
              <div class="col-sm-12 table-responsive">
                <table
                  aria-describedby="example1_info"
                  role="grid"
                  id="example1"
                  class="table table-bordered table-striped"
                >
                  <thead>
                    <tr role="row">
                      <th style="width: 10%;">ID</th>
                      <th style="width: 65%;">Competência</th>
                      <th style="width: 25%;">Distribuído por</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="even" role="row" v-for="item in dataTable.data" :key="item.id">
                      <td>{{ item.id }}</td>
                      <td>{{ item.data_competencia | competencia }}</td>
                      <td>{{ item.usuario.name }}, em {{ item.created_at | dataFormatada }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="row">
                  <div
                    class="col-sm-5"
                  >Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>
                  <div class="col-sm-7" style="text-align:right">
                    <laravue-pagination
                      :data="dataTable"
                      v-on:pagination-change-page="getDataTable"
                    >
                      <span slot="prev-nav">&lt; Anterior</span>
                      <span slot="next-nav">Próximo &gt;</span>
                    </laravue-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import Alert from "../Alert"; // Importando componente alert

export default {
  data: () => ({
    filtros: {
      pesquisa: "",
      tipo: 1,
      coluna: null,
      ordem: null
    },
    dataTable: {}
  }),
  mounted() {
    this.getDataTable();
  },
  methods: {
    distribuir() {
      let config = this.$store.getters.getHeaderAuth;
      axios
        .get(
          `${this.$store.state.serverURI}/api/distribuicao/getProximaCompetencia`,
          config
        )
        .then(response => {
          let competencia = this.$options.filters.competencia(response.data);
          this.$swal({
            title: `Deseja distribuir a competência ${competencia}?`,
            type: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
            cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
            reverseButtons: true
          }).then(result => {
            if (result.value) {
              this.$swal({
                title: "Aguarde...",
                imageUrl: "/static/img/Rolling-green.gif",
                showConfirmButton: false,
                allowOutsideClick: false
              });
              axios
                .post(
                  `${this.$store.state.serverURI}/api/distribuicao/create`,
                  null,
                  this.$store.getters.getHeaderAuth
                )
                .then(response => {
                  if (response.data.status) {
                    this.$swal({
                      type: "success",
                      title: "Competência distribuida com sucesso!",
                      showConfirmButton: false,
                      timer: 1500
                    });
                    this.getDataTable();
                  } else {
                    this.$swal({
                      type: "error",
                      title: response.data.msg
                    });
                  }
                })
                .catch(error => {
                  this.$swal({
                    type: "error",
                    title: error
                  });
                });
            }
          });
        })
        .catch(error => {
          this.$store.commit("throwException", error);
          console.log(error);
        });
    },
    getDataTable(page) {
      if (typeof page === "undefined") {
        page = 1;
      }
      this.filtros.page = page;
      this.$store.commit("TOGGLE_LOADING");
      let config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;
      axios
        .get(
          `${this.$store.state.serverURI}/api/distribuicao/getAllPaginate`,
          config
        )
        .then(response => {
          this.dataTable = response.data;
          console.log(this.dataTable);
          this.$store.commit("TOGGLE_LOADING");
        })
        .catch(error => {
          this.$store.commit("throwException", error);
        });
    }
  },
  watch: {
    page: function(val) {
      this.getDataTable();
    }
  },
  components: {
    Alert
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// index.vue?5337178a